import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function VerticalAlignBottomIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 24 24">
      <path
        d="M19 18.4q.424 0 .712.288.288.287.288.712 0 .424-.288.713A.97.97 0 0 1 19 20.4H5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 19.4q0-.424.287-.712A.97.97 0 0 1 5 18.4zm-7-16q.424 0 .713.287.287.288.287.713v9.2l1.9-1.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7l-3.6 3.6q-.15.15-.325.213a1.1 1.1 0 0 1-.375.062q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-3.6-3.6a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l1.9 1.9V3.4q0-.424.287-.713A.97.97 0 0 1 12 2.4"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
